export const products = [
  {
    id: 'Dahlia',
    name: 'Dahlia',
    mainImage: '1Q3YyWnUA2TNKSLVJF7fZfax-t5jIG0e-',
    images: [
      '1Q3YyWnUA2TNKSLVJF7fZfax-t5jIG0e-',
      '1OMETlbLu1sy3ZJJt7xahtyuEJvXHXJwC',
      '1TBy_7FFvBAhGi3HXi7MKLHZXvf6RawYt',
      '1hDgPrCzZtMSlWaB9nsCFGaC1ZJ90ibDp',
    ],
    description: 'Satin; structured curved low-waist; corset bodice; sweetheart neckline; voluminous Organza skirt adorned with three-dimensional fabric flowers; ballgown flows into chapel-length train. Offered with removable and strategically placed three-dimensional floral sleeve and veil.',
    collection: 'romance',
  },
  {
    id: 'Dede',
    name: 'Dede',
    mainImage: '1ZGrbji4kEq9DvfcnEWSTIl6-cNkKJQkj',
    images: [
      '1ZGrbji4kEq9DvfcnEWSTIl6-cNkKJQkj',
      '1_oFozTm5SfVOzwuTzhl-LAWbscWCqq1Y',
    ],
    description: 'Raised corded jacquard fabric; full A-line side-pleated skirt with pockets and optional covered buttons; back flows into chapel-length train; Basque waist, corset-structured bodice with curved neckline and bralette.',
    collection: 'romance',
  },
  {
    id: 'Dream',
    name: 'Dream',
    mainImage: '1LGkTNIm-Q1GJTAnaeWejQmj69sNy-ezR',
    images: [
      '1LGkTNIm-Q1GJTAnaeWejQmj69sNy-ezR',
      '1ICbtM4pPrzPEw3cv-F49W_mzLrb3jCwa',
      '1fqERoXpMxTuXEbYlLAuvRwArycjgOiDp',
      '1GJLTu6-gL2DG81t8wLozoupu1Xd9Ou_d',
      '1kpnGGnPDQWpwEuBMLx1MTwAEcrgMakdp'

    ],
    description: 'Duchesse Satin; long torso; structured corset bodice paired with a classic catseye neckline with removable shoulder straps; pleated voluminous skirt that flows into a chapel-length train.',
    descriptionOptional: 'Optional: Silver Beading.',
    collection: 'romance',
  },
  {
    id: 'Dani',
    name: 'Dani',
    mainImage: '1eixUYZvrC6jhbiAWT6bOmTUgBN33rdEo',
    images: [
      '1eixUYZvrC6jhbiAWT6bOmTUgBN33rdEo',
      '1gX9H1_wgIHJm7GHN-EZHQh7uEiU3qzqH',
      '1gG1nzLSvz1wN-LhODGRuMvEu5vS7oijd',
      '14knHVixPSFdVy9eGJTMLAPne5U0Bnvuy',
    ],
    description: 'Mikado; sweetheart neckline; princess seam modified A-Line silhouette with back buttons; chapel-length train.',
    descriptionOptional: 'Optional: Chantilly lace Basque waist jacket features back buttons, long sleeves with buttons and banded collar to be worn over or under garment.',
    collection: 'romance',
  },
  {
    id: 'Dakota',
    name: 'Dakota',
    mainImage: '1wLl2br_9PJ1xtZxtleGLTxVj1d6P7OLN',
    images: [
      '1wLl2br_9PJ1xtZxtleGLTxVj1d6P7OLN',
      '11LXy0O4J1ROI2VuMquFWVV8h_8iHS1hw',
      '11xuRO6IrRp1Fe0BbrIbS0iPhD4vKffsH',
      '1YPHcd_y1W7CLG-LiWzn70LFeI-ere_xh',
    ],
    description: 'Trumpet silhouette in Refined Chic Crepe with slight curved and intentional figure flattering diagonal pleated bodice; scalloped sleeves; removable, yet transformative chapel-length train with floral decal over skirt.',
    collection: 'romance',
  },
  {
    id: 'Dia',
    name: 'Dia',
    mainImage: '1WGMN47T_Qx9jqRccy-rgLp5JzBLDljCD',
    images: [
      '1WGMN47T_Qx9jqRccy-rgLp5JzBLDljCD',
      '1e2l6ApEWFgUVRToQna6ZXGhNmI-4s0u0',
      '15v8GY3utgCQPgGToQ9O8ZylSRxCsnTb6',
    ],
    description: 'Luxurious Raised Jacquard; Trumpet-style arched neckline, sculptural bodice with soft Basque waist detail; back covered button; scalloped sleeve; removable, yet transformative chapel-length train over skirt.',
    collection: 'romance',
  },
  {
    id: 'Darcy',
    name: 'Darcy',
    mainImage: '1HICMB8EuqiJUz3mrZPIggl0JDeLCK84C',
    images: [
      '1HICMB8EuqiJUz3mrZPIggl0JDeLCK84C',
      '1y_jkY0Cu6a0ILdulJmUW9EP7iShv2XV2',
    ],
    description: 'Col Bateau neckline, Refined Chic Crepe; Trumpet Silhouette wrap dress with slightly ruched bodice and hip; long side slit.',
    collection: 'romance',
  },
  {
    id: 'Danika',
    name: 'Danika',
    mainImage: '1PUd8RfymUUk_sAg-1HPeOSor5eOMWP9k',
    images: [
      '1PUd8RfymUUk_sAg-1HPeOSor5eOMWP9k',
      '1vjgNCcLfjn6NZAmICHVRpRCuSa1CO91r',
      '1Dsfs5PBWtMGHcFC4yffoCg3ibUBbgJ65',
      '1pGxGPThomm5APU1iNzC26VuDOZ94j-ZZ',
      '116aFVyoWVz75xQsyevHFOU0QVwt1LLX2',
    ],
    description: 'Soft sweetheart neckline, laser-cut embroidered florals and petals; ballgown flows into chapel-length train. Romantic yet feminine opaque Tulle and Organza; figure flattering silhouette.',
    collection: 'romance',
  },
  {
    id: 'Diana',
    name: 'Diana',
    mainImage: '1cUnD9bummKkfh69jzC17m73-XcqF4KTX',
    images: [
      '1cUnD9bummKkfh69jzC17m73-XcqF4KTX',
      '1E0b0122638Pp2wejtYCx_juRMFFDwlwt',
      '1lyQJ8juqur4heA2OxBeqS_jd3h5_gbVP',
      '1M-5zMykNFHDv9Lgzqekk2TbliOyhhhTf',
      '1qPPNbVz-saIWcIuQrZQWhoMj2Z8AB52S',
      '1lG4e8OW6HfyHb8XbWwPOXPISsEfy0NIg',
    ],
    description: 'Laser-cut delicate florals with beaded embroidery bodice that flows into ethereal chapel train; removable sleeve and neck band. Superior quality Satin Chiffon full skirt with high side slit.',
    collection: 'romance',
  },
  {
    id: 'Deja',
    name: 'Deja',
    mainImage: '1Zb5pNk1IsYvB7Sb-IuOC3e-a24kKCqqT',
    images: [
      '1Zb5pNk1IsYvB7Sb-IuOC3e-a24kKCqqT',
      '1ecKjoj7foynhuAP_1bXOgg2AItxbEKz8',
      '1M_ZVAeeRtk9oa8O5JAnopzK3hCD36xjB',
    ],
    description: 'Halter neck; figure-flattering Trumpet Silhouette with three-dimensional laser-cut embroidered leaves and vines diagonally placed over light nude lining.',
    collection: 'romance',
  },
  {
    id: 'Daphne',
    name: 'Daphne',
    mainImage: '1fl6s7WuYXLwilUuRqgPDnsD9pDmfMjDN',
    images: [
      '1fl6s7WuYXLwilUuRqgPDnsD9pDmfMjDN',
      '1bid-1kyNE95lfpdKlFhsInVKS4Xx1EiH',
      '1EHvmWckTHr9aQvT7an_sTbL2YQBlFtkh'
    ],
    description: 'Satin and Tulle ballgown; voluminous skirt with floral pickup corsage along sides of soft layered tulle; structured curved low-waist corset bodice; sweetheart neckline.',
    collection: 'romance',
  },
  {
    id: 'Dora',
    name: 'Dora',
    mainImage: '1_88XvOa8hvCU4ydcKg-6c0_Dw8RaLbkY',
    images: [
      '1_88XvOa8hvCU4ydcKg-6c0_Dw8RaLbkY',
      '1_njsLhhTXeuQPKfPtBGxUjHyYvaeEUtt',
      '1ooFlIsg-JpRUUtLbdg2mnto4Uto3JPuL',
      '1uZdpKpxBOrBUcZUITOJO0WKdjq_Pr5_c',
    ],
    description: 'Chantilly beaded lace with pearls; A-line silhouette with slightly arched neckline; Satin covered removable belt and long with Blow detail. This style offers a soft, mesh body suit with matching lace top and long sleeve.',
    collection: 'romance',
  },
  {
    id: 'Della',
    name: 'Della',
    mainImage: '1uQF_NDnjcRVO85_aJoMIg88qrD5_-Qss',
    images: [
      '1uQF_NDnjcRVO85_aJoMIg88qrD5_-Qss',
      '1HF_8Fn335BJ15AXvP4psb048eFJWqFbb',
      '1HXlxR6p9DTqw70aLaWKrp4a1sb8eHJtE',
      '1ONVeh32wcCNHNJotmk-l_8jXM1VJfh8q',
      '1d2p2AGZNqHf1Ev-4g5E2BA6Z4O-k3xsH',
    ],
    description: 'Multi-layered ruched sweetheart neckline; full soft Tulle skirt that flows into chapel-length train; Removable shoulder band and antique floral waist brooch. Offered in off-white and pale pink.',
    collection: 'romance',
  },
  {
    id: 'Destiny',
    name: 'Destiny',
    mainImage: '1kniP_ifb5NroGVHFghaVdAQeLD0yFPeX',
    images: [
      '1kniP_ifb5NroGVHFghaVdAQeLD0yFPeX',
      '1ACinHKb9ItmL4UdODuzXMFg85bnfMffm',
      '13iuUGzXB6p4AdOlHVILKdK2WpxrbqKhL',
    ],
    description: 'Satin Trumpet with embroidered laser cut leaves and florals; beaded lace bodice; side slit; removable fitted sleeve; soft ruching adorns the lower waist and hip.',
    collection: 'romance',
  },
  {
    id: 'Dori',
    name: 'Dori',
    mainImage: '1qJUGXwHPAYQM17t-n03lAE_63jxq_ez2',
    images: [
      '1qJUGXwHPAYQM17t-n03lAE_63jxq_ez2',
      '1ei2ULkJvpI75h7Lv2Pbxbm_-_V7G3kPS',
    ],
    description: 'Square neckline with soft drapes along bust; small ballgown that flows into chapel-length train; optional covered back buttons; removable fabric-covered belt.',
    collection: 'romance',
  },
  {
    id: 'Dalida',
    name: 'Dalida',
    mainImage: '1Xibi29xSchZ-jGES56TgN7ZQOAxs5Jz3',
    images: [
      '1Xibi29xSchZ-jGES56TgN7ZQOAxs5Jz3',
      '1KN0AOC6OUBv6d1Sw6-AFQXoJT5sPEi2p',
      '1a4yhOuVUiJsVqokuwKgPqr_72BZUY7hM',
    ],
    description: 'Boning detailed Basque bodice; Chantilly lace with sparkle; fit and flare skirt; volume-enhancing godet inserts; matching, long-sleeved bolero jacket with banded collar. This gown is offered with a matching chapel-length Veil.',
    collection: 'romance',
  },
  {
    id: 'Dina',
    name: 'Dina',
    mainImage: '16Ak73M8en8-IH5pUmhvZwTmjsY8_S8tw',
    images: [
      '16Ak73M8en8-IH5pUmhvZwTmjsY8_S8tw',
      '1bytYsTeIhyFc4AfzKd6KwYb860tZwOfm',
      '1SPhBbKK6bLWTm1vmsyABWLjbe2vZ41NC',
      '1IbxaI7jqjxUgxd6iB7MYxozkz-saNhKw',
    ],
    description: 'Chantilly corded lace; structured bodice Basque waist; fit and flare; optional side slit; chapel-length train; removable gauntlet sleeves. This gown is offered with a chapel-length veil with a blusher.',
    collection: 'romance',
  },
  {
    id: 'Demi',
    name: 'Demi',
    mainImage: '1Y3sQQjn6ORnXaRj5uVfZqnv2Vq454HhQ',
    images: [
      '1Y3sQQjn6ORnXaRj5uVfZqnv2Vq454HhQ',
      '1iJa-pLEZpsc_7n6P1hPbBjyhawDb7617',
      '1wuzUdqpmt2wPn-JO8Lo_Abtp_VIM71o1',
      '1a0ErEQejJTUu1QFaz1XpGw2dl1CeiK7a',
    ],
    description: 'straight neckline; structure Basque bodice; elongated waist dreamy ballgown; removable hip bows; Tulle Sunray pleated skirt that flows into chapel-length train.',
    collection: 'romance',
  },
  {
    id: 'Dua',
    name: 'Dua',
    mainImage: '1HfpB8VOlIOmCa1BIRkqVPJ0aDFHbaN1o',
    images: [
      '1HfpB8VOlIOmCa1BIRkqVPJ0aDFHbaN1o',
      '1_bx3LapabaFcTQuN1Q7DJzrZjQ6yLu-j',
      '1dskfmFQOPsvVr64RiBITPbMr4kXRDlXs',
      '13LKOvQl8FlEw8uSE9H2IxgcmRmba9LhH',
      '1fOzzSwP9Pv8Ok11rNguV_KL3JgPXeCF0',
    ],
    description: 'Mikado; sweetheart neckline; princess seam Basque waist bodice; full ball gown skirt that flows into chapel-length train.',
    descriptionOptional: 'Optional: Shoulder straps; Chantilly lace; banded collar cap sleeve or halter top',
    collection: 'romance',
  },
  {
    id: 'Doris',
    name: 'Doris',
    mainImage: '1SRlckIIKI0V92UFc7j2CTpnxbIaRAkjS',
    images: [
      '1SRlckIIKI0V92UFc7j2CTpnxbIaRAkjS',
      '1PER6_wkdVgITgbwidT-yZUOfT6ORDjc9',
      '1IwWk6Y5eDNBr5cUGm2fTjQdBfkfBcQXh'
    ],
    description: 'Guipure lace; semi-circular skirt; sweetheart neckline; delicate floral ball gown with shimmering sparkle over three ply Organza; chapel-length train.',
    collection: 'romance',
  },
  {
    id: 'Delina',
    name: 'Delina',
    mainImage: '1IoiIqdhm9g3FYYaKJpHnQDoT55jfqdb9',
    images: [
      '1IoiIqdhm9g3FYYaKJpHnQDoT55jfqdb9',
      '1UofvASpS2OEL75fOxwQc8H7s7zymUb2Z',
      '1ijJ3zCRrFrnkct9gulIB11l61eDqp8om',
      '1OUOrWyFiH0i4WkYhipsKpo9OKSgCOZVR',
      '15cvVo6oviKZKJKImcC3Y3hEytu4QbHyj'
    ],
    description: 'Mikado; Empire-waist; square neckline; princess seams fit-and-flare flows into chapel-length train.',
    descriptionOptional: 'Optional: 3-dimensional floral vest and removable bow.',
    collection: 'romance',
  },
  {
    id: 'Dale',
    name: 'Dale',
    mainImage: '1mPhJT4n4lD67BYWBPgl6ajRKPIvgwk7s',
    images: [
      '1mPhJT4n4lD67BYWBPgl6ajRKPIvgwk7s',
      '11W2hyOqeFQC0nmTjOP_BKKJNu3ONsVMu',
      '1E7vZZtsOo9-K_BFdE95ro-M7MDmTsBaS'
    ],
    description: 'Mikado; lace trimmed neckline; Peplum Bustier with back fabric-covered buttons; front belt detail and trumpet style skirt flow into chapel-length train.',
    collection: 'romance',
  },
  {
    id: 'Dezirae',
    name: 'Dezirae',
    mainImage: '1dBmsXahkTShDcirSUU2llkfWY-0UCvwo',
    images: [
      '1dBmsXahkTShDcirSUU2llkfWY-0UCvwo',
      '10hl7eeW9-ulWAzlsr84wso-_fmJ78R-d',
      '1OTDU1QfXAQQBcbQ5DNnwPEtIX8ZNNhDe',
      '13Mbt9ZkMlxkqKlqf9AyRXiIzVOYHEBMu'
    ],
    description: 'Mikado; three-dimensional floral applique bustline and chapel-length train; removable scallop floral sleeve; princess line with sheer corset back and contrasting boning channels.',
    collection: 'romance',
  },
  {
    id: 'Dagny',
    name: 'Dagny',
    mainImage: '134-zu4UYTH1xfq1JVjqk4NjtSMglStB5',
    images: [
      '134-zu4UYTH1xfq1JVjqk4NjtSMglStB5',
      '1WcLU0BUvguTbkY7TyqcqMTu6ZYfZisBh',
      '1JVLP7qSJMVTnJh3gce6B2_jmNt4PSiyE'
    ],
    description: 'Mikado; Basque waist; draped corset neckline with boning detail; trumpet style skirt flows into chapel-length train.',
    descriptionOptional: 'Optional: Chiffon neck scarf.',
    collection: 'romance',
  },
];